<script lang="ts">
  import type { CtaPanelProps } from '$lib/types/contentTypes';
  import { CTA_VARIANT } from '$lib/constants/constants';
  import CtaPanelFull from './CtaPanelFull.svelte';
  import CtaPanelGrey from './CtaPanelGrey.svelte';
  import CtaPanelPink from './CtaPanelPink.svelte';

  export let ctaPanel: CtaPanelProps;
  export let isNarrow: boolean = false;

  let variant = ctaPanel.displayVariant;
  let ctaComponentInstance = CtaPanelFull;

  switch (variant) {
    case CTA_VARIANT.FULL:
      ctaComponentInstance = CtaPanelFull;
      break;
    case CTA_VARIANT.GREY:
      ctaComponentInstance = CtaPanelGrey;
      break;
    case CTA_VARIANT.PINK:
      ctaComponentInstance = CtaPanelPink;
      break;
  }
</script>

<svelte:component this={ctaComponentInstance} {ctaPanel} {isNarrow} />
